import * as React from "react"
import type { SVGProps } from "react"
const SvgSmartToy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 15a3 3 0 0 1-2.12-.87A3 3 0 0 1 1 12q0-1.25.88-2.12A3 3 0 0 1 4 9V7q0-.82.59-1.41Q5.18 4.99 6 5h3q0-1.25.88-2.12A3 3 0 0 1 12 2q1.25 0 2.13.88Q15 3.75 15 5h3q.83 0 1.41.59.6.59.59 1.41v2q1.25 0 2.13.88.87.87.87 2.12t-.87 2.13A3 3 0 0 1 20 15v4q0 .83-.59 1.41-.59.6-1.41.59H6q-.82 0-1.41-.59-.6-.59-.59-1.41zm6.06-2.44q.45-.43.44-1.06 0-.63-.44-1.06Q9.63 9.99 9 10q-.63 0-1.06.44-.44.43-.44 1.06t.44 1.06q.43.45 1.06.44.63 0 1.06-.44m6 0q.45-.43.44-1.06 0-.63-.44-1.06-.43-.45-1.06-.44-.63 0-1.06.44-.45.43-.44 1.06 0 .63.44 1.06.43.45 1.06.44.63 0 1.06-.44M8 17h8v-2H8zm-2 2h12V7H6z" />
  </svg>
)
export default SvgSmartToy
